/**
 * Filter assets to those whose type is in the selected type list.
 *
 * Empty / missing `assetTypes` returns no matches — not every asset.
 * That matches "All Matching Assets" counts: types must be chosen first.
 */
export function filterAssetsByTypes<T extends { type: string }>(
  assets: T[],
  assetTypes: string[] | null | undefined
): T[] {
  if (!assetTypes?.length) {
    return [];
  }

  return assets.filter((asset) => assetTypes.includes(asset.type));
}
